<script>
    import {
        Button,
        Badge,
        Card,
        Col,
        CardBody,
        CardFooter,
        CardHeader,
        CardSubtitle,
        CardText,
        CardTitle,
        Tooltip,
    } from 'sveltestrap';
    export let singleTourn;
</script>

<Col xs="auto">
    <Card xs="auto" class="mb-3">
        <CardHeader>
            <CardTitle>{singleTourn.date}</CardTitle>
        </CardHeader>
        <CardBody id={`frm-${singleTourn.folder}`}>
            <CardSubtitle>{singleTourn.label}</CardSubtitle>

            <a href="/{singleTourn.folder}">
                <Button disabled={!singleTourn.active} color="primary"
                    >Wyniki</Button
                >
                {#if !singleTourn.active}
                    <Tooltip
                        target={`frm-${singleTourn.folder}`}
                        placement="top"
                        >Turniej się jeszcze nie rozpoczął</Tooltip
                    >
                {/if}
            </a>{#if singleTourn.active === 'live'} <Badge>Live!</Badge>{/if}
        </CardBody>
    </Card>
</Col>
